import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React, { useState } from 'react';

const CalenderCell = () => {
  const [value, setValue] = useState<Date | null>(null);

  return (
    <div className={'grid-item-calender'}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value}
          onChange={(newValue) => setValue(newValue)}
          sx={{ height: 30, '& .MuiInputBase-root': { height: 30 } }}
          inputFormat="DD/MM/YYYY"
          key={Math.random()}
        />
      </LocalizationProvider>
    </div>
  );
};

export default CalenderCell;
